import type { LearnBrandOverrides } from '../types'

/**
 * AI Coding Patterns. These values used to live in defaults.ts, which made ACP
 * the baseline every other brand inherited without noticing.
 */
export const overrides: LearnBrandOverrides = {
  id: 'acp',
  name: 'AI Coding Patterns',
  learn: {
    // Every UI language gets the branded tagline; the locale files only carry
    // the neutral "{{brand}}" fallback for brands that do not declare one.
    footer: {
      en: 'AI Coding Patterns — Learn programming with AI',
      es: 'AI Coding Patterns — Aprende programación con IA',
      cs: 'AI Coding Patterns — Naučte se programovat s AI',
      de: 'AI Coding Patterns — Programmieren lernen mit AI',
      fr: "AI Coding Patterns — Apprenez la programmation avec l'AI",
      it: "AI Coding Patterns — Impara a programmare con l'AI",
      ko: 'AI Coding Patterns — AI와 함께 프로그래밍을 배우세요',
      nl: 'AI Coding Patterns — Leer programmeren met AI',
      pl: 'AI Coding Patterns — Ucz się programowania z AI',
      pt: 'AI Coding Patterns — Aprenda a programar com AI',
      ro: 'AI Coding Patterns — Învață programare cu AI',
      sv: 'AI Coding Patterns — Lär dig programmera med AI',
      tr: 'AI Coding Patterns — AI ile programlama öğrenin',
      uk: 'AI Coding Patterns — Вивчайте програмування з AI',
    },
  },
  legal: {
    terms: { es: 'https://aicodingpatterns.com/legal/terms/', en: 'https://aicodingpatterns.com/en/legal/terms/' },
    privacy: { es: 'https://aicodingpatterns.com/legal/privacy/', en: 'https://aicodingpatterns.com/en/legal/privacy/' },
    refunds: { es: 'https://aicodingpatterns.com/legal/refunds/', en: 'https://aicodingpatterns.com/en/legal/refunds/' },
  },
  assets: {
    logo: '/ai_coding_patterns2.png',
    logoLight: '/ai_coding_patterns2blanco.png',
  },
  monitoring: {
    sentryDsn: 'https://f7ed0401cae8818f53acaed5d5b0b705@o482391.ingest.us.sentry.io/4511133558767616',
    apiHost: 'learn.aicodingpatterns.com',
  },
  theme: {
    colors: {
      blue: '#0570b3',
      blueLight: '#4ba3de',
      blueSoft: '#e8f2fb',
      bluePress: '#045c99',
      blueStrong: '#034a7c',
      gold: '#d5b656',
      goldSoft: '#faf4e2',
      goldStrong: '#8a7220',
      purple: '#9673a6',
      purpleSoft: '#f1ecf4',
      purpleStrong: '#6e4f7e',
      green: '#82b366',
      greenSoft: '#eef6e8',
      greenStrong: '#5a8a40',
      red: '#d0563f',
      redSoft: '#fbeae6',
      redStrong: '#b23b26',
      ink: '#12141c',
      inkSoft: '#454b5a',
      inkFaint: '#6b7182', // AA: #8a90a0 daba 3.19:1 sobre blanco (WCAG AA pide 4.5:1)
      bg: '#ffffff',
      bgSoft: '#f7f8fa',
      surface: '#ffffff',
      surfaceAlt: '#f7f8fa',
      line: '#eceef2',
      lineStrong: '#dee1e7',
    },
    fonts: {
      // Consolidated 3-font system: Space Grotesk (logo + headings),
      // Hanken Grotesk (body/UI), Jersey 25 (pixel "HUD" accent — eyebrows
      // only). Jersey 15 lives ONLY in the blog landing (huge hero text);
      // learn has no hero, so `display` falls back to the heading face.
      heading: "'Space Grotesk', sans-serif",
      body: "'Hanken Grotesk', sans-serif",
      mono: "ui-monospace, SFMono-Regular, 'SF Mono', Menlo, monospace",
      display: "'Space Grotesk', sans-serif",
      eyebrow: "'Jersey 25', 'Space Grotesk', sans-serif",
    },
    radii: {
      card: '16px',
      button: '12px',
    },
    googleFontsUrl:
      'https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;500;600;700&family=Jersey+25&family=Space+Grotesk:wght@400;500;600;700&display=swap',
  },
}
